import * as React from "react";

import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "lib/utils";

interface ProgressProps
  extends React.ComponentProps<typeof ProgressPrimitive.Root> {
  /** Progress value from 0 to 100 */
  value?: number;
  /** Status of the progress bar */
  status?: "default" | "success" | "active";
}

function Progress({
  className,
  value = 0,
  status = "default",
  ...props
}: ProgressProps) {
  const indicatorColor =
    status === "success" || value === 100
      ? "bg-green-500"
      : status === "active"
        ? "bg-blue-500"
        : "bg-primary";

  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        "bg-primary/20 relative h-2 w-full overflow-hidden rounded-full",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "h-full w-full flex-1 transition-all duration-300",
          indicatorColor
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
